import {io} from 'socket.io-client';

class SocketioService{
    socket;
    constructor(){}
    setupSocketConnection(){
        //this.socket = io('http://192.168.30.217:5010',{
        //this.socket = io('http://192.168.30.148:5010',{
        //this.socket = io('http://192.168.30.102:82',{
        //this.socket = io('http://192.168.30.143:5010',{
        this.socket = io('http://socket.portailsvx.ca/',{
        
            auth: {
                token: '123'
            },
            path: "/socket/"
        });
        this.socket.emit('message', 'Hello World');
        this.socket.on('myBroadcast', (data) => {
            console.log('=====> Server : ', data);
        });
    }
    disconnect(){
        try{
            if(this.socket){
                this.socket.disconnect();
            }
        }
        catch(error){return "TEST : " + error}
    }   
    getSocket(){
        try{
            return this.socket;
        }
        catch(error){return "TEST : " + error}

    }   
}

export default new SocketioService();